<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('leave_balance') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i
                    class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onGenerate"><i class="fa fa-calculator"></i> {{ $t("post_balance") }}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.Year">
                                        <option value="2021">2021</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                                <th width="300px">{{$t('code')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-center">{{$t('leave_qty_yearly')}}</th>
                                <th class="text-center">{{$t('leave_qty_forward')}}</th>
                                <th class="text-center">{{$t('leave_qty_extra')}}</th>
                                <th class="text-center">{{$t('leave_taken')}}</th>
                                <th class="text-center">{{$t('balance')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.LeaveType.Code}}</td>
                                <td>{{ret.LeaveType.Description}}</td>
                                <td class="text-right">{{ret.LeaveBalance.Entitle}}</td>
                                <td class="text-right">{{ret.LeaveBalance.Earned}}</td>
                                <td class="text-right">{{ret.LeaveBalance.Extra}}</td>
                                <td class="text-right">{{ret.LeaveBalance.Taken}}</td>
                                <td class="text-right">{{ret.LeaveBalance.Balance}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function Select() {
            return {
                query: {
                    Id: this.$route.params.id,
                    Year: this.$now().format('YYYY')
                },
                list: []
            }
        },
        created: function () {
            this.toList();
        },
        methods: {
            toList() {
                let loading = this.$loading.show();
                this.$api().post('leave/balance', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.LeaveBalances;
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            onGenerate(){
                let loading = this.$loading.show();
                this.$api().post('generate/balance', { Id: this.$route.params.id }).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.LeaveBalances;
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
</script>